import { useState } from 'react';
import { QueryState } from '../components/page';
import { usePrescreeningRuns } from '../api/hooks';
import { control } from './practice-agents';
import {
  PRESCREENING_UNAVAILABLE,
  PrescreeningHeader,
  RunsTable,
  prescreeningLoadError,
} from './prescreening';

type DraftFilter = 'all' | 'approved' | 'draft';

const DRAFT_FILTERS: { value: DraftFilter; label: string }[] = [
  { value: 'all', label: 'All runs' },
  { value: 'approved', label: 'Approved versions' },
  { value: 'draft', label: 'Drafts' },
];

export function PrescreeningRunsPage() {
  const [filter, setFilter] = useState<DraftFilter>('all');
  const runs = usePrescreeningRuns(filter === 'all' ? {} : { draft: filter === 'draft' });

  return (
    <div>
      <PrescreeningHeader />
      <QueryState isLoading={runs.isLoading} error={prescreeningLoadError(runs.error)}>
        {runs.data === null ? (
          <p role="status" className="text-sm text-muted-foreground">
            {PRESCREENING_UNAVAILABLE}
          </p>
        ) : (
          <>
            <div className="mb-4 flex flex-wrap items-end gap-3 rounded-3xl border bg-card p-4">
              <label className="flex flex-col gap-1 text-xs text-muted-foreground">
                Versions
                <select
                  aria-label="Versions"
                  className={control}
                  value={filter}
                  onChange={event => setFilter(event.target.value as DraftFilter)}
                >
                  {DRAFT_FILTERS.map(option => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </label>
              <p className="max-w-xl text-xs text-muted-foreground">
                Runs send counts only, and a count from 0 to 4 shows as fewer than 5. This page
                shows the latest 200 runs.
              </p>
            </div>
            <RunsTable
              runs={runs.data ?? []}
              empty={
                filter === 'all'
                  ? 'No runs yet. A practice computer runs each criteria query after every import.'
                  : 'No runs match this filter.'
              }
            />
          </>
        )}
      </QueryState>
    </div>
  );
}
